import Footer from 'components/Footer';
import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { getHotelStatic } from 'src/api/hotelApi';
import { useEffect } from 'react';
import { hotelAction } from 'src/redux/actions';
import OrganizationHeader from 'components/OrganizationHeader';
import ScrollTop from 'src/components/ScrollTop';

type HotelLayoutProps = {
   children: any;
};

const BookingLayout = (props: HotelLayoutProps) => {
   const dispatch = useDispatch();
   const { children } = props;

   const { data } = useQuery({
      queryKey: ['getHotelStatic'],
      queryFn: getHotelStatic,
      retry: false,
      staleTime: Infinity,
   });


   useEffect(() => {
      if (data?.data) {
         dispatch(hotelAction.setHotelStatic(data?.data));
      }
   }, [data?.data]);

   return (
      <div className="booking-layout flex-1 min-h-screen flex flex-col justify-between items-center bg-white">
         <ScrollTop />
         <OrganizationHeader showMyTrips />
         <div className="flex-1 w-full">{children}</div>
         <Footer />
      </div>
   );
};

export default BookingLayout;
